/* IMPORTS
	You can import directly from node_modules here.
*/
import $ from 'jQuery';
import 'what-input';

/*
	LIBRARY IMPORTS
	Utilities, plugins, and behaviors that aren't tied to a specific component.
*/
import alerts from './libraries/alerts';
import anchorLinks from './libraries/anchor-links';
import linkContainer from './libraries/link-container';
import './libraries/filters';
import './libraries/filters-books';
import './libraries/hoverintent.min.js';
import './libraries/slick.min.js';
import './libraries/what-input.js';
import './libraries/ScrollTrigger.min.js';

/*
	COMPONENT IMPORTS
	For specific components.
*/
import '../blocks/accordion-block/js/accordion-block';
import '../blocks/two-column-hours/js/two-column-hours.js';
import '../blocks/two-column-with-menu/js/two-column-with-menu.js';
import imagesAutoSlider from '../blocks/hero/js/hero.js';
import textImageCarousel from '../blocks/text-image-carousel/js/text-image-carousel.js';
import fourColumnList from '../blocks/four-column-list/js/four-column-list.js';
import fullwidthLinksList from '../blocks/fullwidth-links-lists/js/fullwidth-links-lists.js';
import featuredBranchEvents from '../blocks/featured-branch-events/js/featured-branch-events';
import recommendedReads from '../blocks/recommended-reads/js/recommended-reads';
import threeColumnArticles from '../blocks/three-column-articles/js/three-column-articles';

// import '../modules/some-module/js/some-module';
import './components/alerts.js';
import './components/cookies.js';
import './components/accessibility.js';
import './components/header.js';
import './components/main-menu.js';
import './components/search.js';

// Easy console access to jQuery through '$'
window.$ = $;

/* INITIALIZATION */
$(() => {
  $('body').addClass('document-ready');
});

$(document).ready(function() {
	/* Higher priority first, lower priority later */
	alerts();
	linkContainer();
	anchorLinks();
	imagesAutoSlider();
	textImageCarousel();
	fourColumnList();
	fullwidthLinksList();
	featuredBranchEvents();
	recommendedReads();
	threeColumnArticles();
});

// FOUC on-fully-loaded make the page visible:
addEventListener('load', (e) => {
  document.documentElement.style.visibility = 'visible';
});